import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';

import { UserListRow_user$key } from '__generated__/UserListRow_user.graphql';

type Props = EntityTableRowProps & {
  user: UserListRow_user$key;
};

const UserListRow: FC<Props> = ({ user, ...props }) => {
  const userData = useFragment(
    graphql`
      fragment UserListRow_user on User {
        id
        name
        email
        canPublish

        ...EntityTableRow_entity
      }
    `,
    user
  );

  const { id, name, email, canPublish } = userData;

  return (
    <EntityTableRow entity={userData} {...props}>
      <TableCell>
        <Link href={`/users/${id}`}>{name}</Link>
      </TableCell>

      <TableCell center>{email}</TableCell>
      <TableCell center>{canPublish ? 'Taip' : 'Ne'}</TableCell>
    </EntityTableRow>
  );
};

export default UserListRow;
